<!--
 * @Description: 百分比分析
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div class="bi-tmpl-detail__right__cmpt">
    <div>
      <span class="bi-tmpl-detail__right__cmpt__title">
        {{ curItem.title }}
      </span>
      <span v-if="curItem.tips" class="bi-tmpl-detail__right__cmpt__tips">
        {{ curItem.tips }}
      </span>
    </div>
    <Carousel ref="carouselRef" :itemHeight="175" :itemWidth="420 + 56">
      <div
        style="height: 160px; width: 100%"
        v-for="(item, index) in TYPE_MAPPING"
        :key="index"
        @click="onChangeFn(item.value)"
      >
        <BaseCard style="width: 420px; height: 160px">
          <BaseRadio
            class="bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w"
            :value="item.value"
            :model-value="curItem.value"
          >
            <component
              style="
                width: 1200px;
                transform: scale(0.32);
                transform-origin: center 0;
              "
              :is="cmpName(item.value)"
              :tableHeaderList="data_4_3.table.header"
              :tableDataList="data_4_3.table.value"
            />
          </BaseRadio>
        </BaseCard>
      </div>
    </Carousel>
    <div class="bi-tmpl-detail__right__cmpt__des">
      {{ data_4_3.resultSystem }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import _ from 'lodash';
import { BaseRadio } from 'xrk-components';
import { BaseCard } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import PcModulePercent from '@V/bi-tmpl/src/components/bi-pc-module/pc-module-task-percent/index';
import { data_4_3 } from '../../../../../../hooks/use-preview';

const CHILD_KEY = '4_3_2';
const TYPE_MAPPING = [1, 2, 3, 4, 5].map(i => {
  return {
    value: 'pc-module-task-percent-' + i,
    index: i
  };
});

const cmpName = name => {
  return PcModulePercent.filter(comp => comp.__name === name)[0];
};

const { curItem, onChange } = useDetailCmpt({ childKey: CHILD_KEY });

const onChangeFn = _.debounce(val => {
  if (curItem.value === val) {
    onChange(null);
  } else {
    onChange(val);
  }
}, 0);
</script>

<style scoped lang="scss">
::v-deep {
  .xrk-radio__input {
    bottom: -52px !important;
  }
}
</style>
